module.exports = require("chai");


//////////////////
// WEBPACK FOOTER
// external "chai"
// module id = 5
// module chunks = 0